import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import API from '@/api/index.js'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$API = API

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
